/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Report_CitationInputs */

const en_dialog_report_citation = /** @type {(inputs: Dialog_Report_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report Citation`)
};

const es_dialog_report_citation = /** @type {(inputs: Dialog_Report_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar cita`)
};

/**
* | output |
* | --- |
* | "Report Citation" |
*
* @param {Dialog_Report_CitationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_report_citation = /** @type {((inputs?: Dialog_Report_CitationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Report_CitationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_report_citation(inputs)
	return en_dialog_report_citation(inputs)
});